import { Routes } from '@angular/router';
import { LoginRouteGuardService } from './services/_core/login-route-guard/login-route-guard.service';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'help',
    loadComponent: () => import('./pages/_core/help/help.page').then( m => m.HelpPage)
  },
  {
    path: 'share',
    loadComponent: () => import('./pages/_core/share/share.page').then( m => m.SharePage)
  },
  {
    path: 'check-for-updates',
    loadComponent: () => import('./pages/_core/check-for-updates/check-for-updates.page').then( m => m.CheckForUpdatesPage)
  },
  {
    path: 'help-forgot-pwd',
    loadComponent: () => import('./pages/_core/help-forgot-pwd/help-forgot-pwd.page').then( m => m.HelpForgotPwdPage)
  },
  {
    path: 'feedback-modal',
    loadComponent: () => import('./pages/_core/feedback-modal/feedback-modal.page').then( m => m.FeedbackModalPage)
  },
  {
    path: 'cases-view',
    loadComponent: () => import('./pages/cases-view/cases-view.page').then( m => m.CasesViewPage)
  },
  {
    path: 'my-account',
    canActivate: [LoginRouteGuardService],
    loadComponent: () => import('./pages/_core/my-account/my-account.page').then( m => m.MyAccountPage)
  },
  {
    path: 'language-modal',
    loadComponent: () => import('./pages/_core/language-modal/language-modal.page').then( m => m.LanguageModalPage)
  },
  {
    path: 'language-popover',
    loadComponent: () => import('./pages/_core/language-popover/language-popover.page').then( m => m.LanguagePopoverPage)
  },
  {
    path: 'language-translator',
    loadComponent: () => import('./pages/_core/language-translator/language-translator.page').then( m => m.LanguageTranslatorPage)
  },
  // {
  //   path: 'assessments',
  //   loadComponent: () => import('./pages/assessments/assessments.page').then( m => m.AssessmentsPage)
  // },
  {
    path: 'redirect',
    loadComponent: () => import('./pages/redirect/redirect.page').then( m => m.RedirectPage)
  },
  {
    path: 'reports',
    loadComponent: () => import('./pages/reports/reports.page').then( m => m.ReportsPage)
  },
  {
    path: 'feedback-modal',
    loadComponent: () => import('./pages/feedback-modal/feedback-modal.page').then( m => m.FeedbackModalPage)
  },
  {
    path: 'select-study-modal',
    loadComponent: () => import('./pages/select-study-modal/select-study-modal.page').then( m => m.SelectStudyModalPage)
  },
  // {
  //   path: 'feedback-other-view-modal',
  //   loadComponent: () => import('./pages/feedback-other-view-modal/feedback-other-view-modal.page').then( m => m.FeedbackOtherViewModalPage)
  // },
  {
    path: 'reports',
    loadComponent: () => import('./pages/reports/reports.page').then( m => m.ReportsPage)
  },
  {
    path: 'manage',
    loadComponent: () => import('./pages/manage/manage.page').then( m => m.ManagePage)
  },
  {
    path: 'manage-tabs',
    loadComponent: () => import('./pages/manage-tabs/manage-tabs.page').then( m => m.ManageTabsPage)
  },
  {
    path: 'manage-main-stage-content',
    loadComponent: () => import('./pages/manage-main-stage-content/manage-main-stage-content.page').then( m => m.ManageMainStageContentPage)
  },
  {
    path: 'open-study-page',
    loadComponent: () => import('./pages/open-study-page/open-study-page.page').then( m => m.OpenStudyPagePage)
  },
  {
    path: 'submission-status',
    loadComponent: () => import('./pages/submission-status/submission-status.page').then( m => m.SubmissionStatusPage)
  },
  {
    path: 'filter-popover',
    loadComponent: () => import('./pages/filter-popover/filter-popover.page').then( m => m.FilterPopoverPage)
  },
  {
    path: 'preview-page',
    loadComponent: () => import('./pages/preview-page/preview-page.page').then( m => m.PreviewPagePage)
  },
  {
    path: 'manage-users',
    loadComponent: () => import('./pages/manage-users/manage-users.page').then( m => m.ManageUsersPage)
  },
  {
    path: 'manage-location',
    loadComponent: () => import('./pages/manage-location/manage-location.page').then( m => m.ManageLocationPage)
  },
  {
    path: 'manage-feedback',
    loadComponent: () => import('./pages/manage-feedback/manage-feedback.page').then( m => m.ManageFeedbackPage)
  },
  {
    path: 'manage-trainee',
    loadComponent: () => import('./pages/manage-trainee/manage-trainee.page').then( m => m.ManageTraineePage)
  },
  {
    path: 'manage-report-tabs',
    loadComponent: () => import('./pages/manage-report-tabs/manage-report-tabs.page').then( m => m.ManageReportTabsPage)
  },
  {
    path: 'manage-report-main-stage-content',
    loadComponent: () => import('./pages/manage-report-main-stage-content/manage-report-main-stage-content.page').then( m => m.ManageReportMainStageContentPage)
  },
  {
    path: 'manage-report-selection',
    loadComponent: () => import('./pages/manage-report-selection/manage-report-selection.page').then( m => m.ManageReportSelectionPage)
  },
  {
    path: 'manage-assignments',
    loadComponent: () => import('./pages/manage-assignments/manage-assignments.page').then( m => m.ManageAssignmentsPage)
  },
  {
    path: 'report-inspectors-individual-review-modal',
    loadComponent: () => import('./pages/report-inspectors-individual-review-modal/report-inspectors-individual-review-modal.page').then( m => m.ReportInspectorsIndividualReviewModalPage)
  }
];
